export default {
	index: {
		title: '{{mainEntityLabelPlural}}',
		subtitle:
			'Explore our comprehensive catalog of {{mainEntityLabelPluralLower}} designed to help you master new skills',
		noCourses: 'No {{mainEntityLabelPluralLower}} found',
		tryDifferentFilters: 'Try different filters or check back later',
		searchPlaceholder: 'Search {{mainEntityLabelPluralLower}}...',
		moveModule: 'Move module',
	},
	catalog: {
		zones: {
			programsHint:
				'{{collectionEntityLabelPlural}} that connect {{mainEntityLabelPluralLower}} into a sequence with intent.',
		},
		meta: {
			title: {
				default:
					'{{mainEntityLabelPlural}} and {{collectionEntityLabelPlural}} catalog',
				courseType: '{{mainEntityLabelPlural}}',
				collectionType: '{{collectionEntityLabelPlural}}',
				category: '{{category}} | {{mainEntityLabelPlural}}',
				subcategory: '{{subcategory}} | {{mainEntityLabelPlural}}',
				pageSuffix: 'Page {{page}}',
			},
			description: {
				default:
					'Explore the catalog of {{mainEntityLabelPluralLower}} and {{collectionEntityLabelPluralLower}} at {{brandTitle}}.',
				courseType:
					'Explore {{mainEntityLabelPluralLower}} to learn with clarity at {{brandTitle}}.',
				collectionType:
					'Discover structured {{collectionEntityLabelPluralLower}} at {{brandTitle}}.',
				category:
					'Explore {{mainEntityLabelPluralLower}} for {{category}} at {{brandTitle}}.',
				subcategory:
					'Explore {{mainEntityLabelPluralLower}} for {{subcategory}} at {{brandTitle}}.',
			},
		},
	},
	entities: {
		course: {
			title: '{{mainEntityLabel}}',
			createCourse: 'Create {{mainEntityLabelLower}}',
			deleteCourse: 'Delete {{mainEntityLabelLower}}',
		},
		module: {
			title: 'Module',
			createModule: 'Create module',
			newModule: 'New module',
			deleteModule: 'Delete module',
		},
		topic: {
			title: 'Topic',
			createTopic: 'Create topic',
			newTopic: 'New topic',
			deleteTopic: 'Delete topic',
		},
		resource: {
			title: 'Resource',
			titlePlural: 'Resources',
			createResource: 'Create resource',
			deleteResource: 'Delete resource',
		},
	},
	detail: {
		breadcrumb: {
			courses: '{{mainEntityLabelPlural}}',
		},
		enroll: 'Enroll now',
		enrolling: 'Enrolling...',
		continueLearning: 'Continue learning',
		whatYouWillLearn: 'What you will learn',
		relatedCourses: 'Related {{mainEntityLabelPluralLower}}',
		applicability: {
			appliesTo: 'Applies to {{country}}',
			needsReview: 'Pending regulatory review',
			deprecated: 'Outdated regulation',
		},
		hero: {
			enroll: 'Start free',
			startLearning: 'Start this {{mainEntityLabelLower}}',
			continueLearning: 'Continue learning',
		},
		stickyCta: {
			stateEnrolled: '{{mainEntityLabel}} activated',
			stateProgramEnrolled: '{{collectionEntityLabel}} activated',
			stateLoggedIn: 'Ready to start',
			stateAnonymous: 'Quick access',
			description:
				'Access this {{mainEntityLabelLower}} without losing your current context.',
			descriptionProgram:
				'Access this {{collectionEntityLabelLower}} without losing your current context.',
		},
		valueProps: {
			title: 'A new way to learn',
			subtitle:
				'Combine the power of AI with expert-curated content for a personalized learning experience',
			features: {
				curated: {
					title: 'Curated content',
					description:
						'Selected resources from platforms like YouTube, the best posts, and more',
				},
				ai: {
					title: 'AI-Powered',
					description:
						'Personalized content using advanced AI to adapt to your learning style',
				},
				notes: {
					title: 'Interactive notes',
					description:
						'Take notes, highlight key concepts, and create your own study materials',
				},
				visual: {
					title: 'Visual learning',
					description:
						'Watch video tutorials and visualize concepts through interactive diagrams',
				},
			},
		},
		objectives: {
			title: "What you'll learn",
		},
		metadataObjectives: {
			title: '{{mainEntityLabel}} objectives',
		},
		highlights: {
			title: '{{mainEntityLabel}} highlights',
		},
		curriculum: {
			title: '{{mainEntityLabel}} content',
			highlightsTitle: '{{collectionEntityLabel}} highlights',
			topics: 'Topics',
			modules: 'Modules',
		},
		faq: {
			title: 'Frequently asked questions',
		},
		related: {
			title: 'More in {{category}}',
			fallbackTitle: 'More recommended {{mainEntityLabelPluralLower}}',
		},
		relationship: {
			eyebrow: 'Part of',
			single:
				'This {{mainEntityLabelLower}} is part of {{collectionEntityArticleLower}} {{collection}}',
			multiple:
				'This {{mainEntityLabelLower}} is part of {{count}} {{collectionEntityLabelPluralLower}}',
			cta: 'View {{collectionEntityLabelLower}}',
		},
		collectionContext: {
			actions: {
				openCollection: 'Open {{collectionEntityLabelLower}}',
				viewCollection: 'View full {{collectionEntityLabelLower}}',
				startThisCourse: 'Start this {{mainEntityLabelLower}}',
				takeCourseOnly: 'Take only this {{mainEntityLabelLower}}',
				addCollection: 'Add {{collectionEntityLabelLower}}',
				chooseProgram: 'Choose {{collectionEntityLabelLower}}',
			},
			disambiguation: {
				title: 'Where do you want to continue?',
				openProgram: 'Open',
				takeCourseOnly: 'Take only this {{mainEntityLabelLower}}',
			},
			promote: {
				eyebrow: 'Recommended',
				title: 'Take this {{mainEntityLabelLower}} inside {{collection}}',
				description:
					'You will see the full path, shared progress, and the next step in the {{collectionEntityLabelLower}}.',
			},
			resume: {
				eyebrow: 'You are already in this {{collectionEntityLabelLower}}',
				title: '{{collection}} is already in your dashboard',
				description:
					'Open the {{collectionEntityLabelLower}} to keep the context and resume from a single guided view.',
			},
			attach: {
				eyebrow: 'Add the bigger picture',
				title: 'Add {{collection}} to your dashboard',
				description:
					'You have already started this {{mainEntityLabelLower}}. If you add the {{collectionEntityLabelLower}} too, you will keep the whole path in one place.',
			},
			finalCta: {
				title: 'Start with the full {{collectionEntityLabelLower}}',
				subtitle:
					'{{collection}} places this {{mainEntityLabelLower}} inside the broader path so the context and next steps stay visible.',
			},
		},
		otherCollections: {
			title: 'Other {{collectionEntityLabelPluralLower}}',
			cta: 'View {{collectionEntityLabelLower}}',
		},
		experience: {
			genericTitle: 'What you can expect from this path',
			genericIntro:
				'A clear structure to build momentum, keep context, and connect each step with what comes next.',
			points: {
				guidedPace: {
					title: 'A guided pace that is easy to resume',
					description:
						'Each block helps you understand what to tackle first and how to continue without losing the thread.',
				},
				connectedContext: {
					title: 'Content that stays connected',
					description:
						'Content and modules stay ordered so the relationship between concepts stays visible as you move forward.',
				},
				practicalProgress: {
					title: 'Practical progress from the start',
					description:
						'You are not just collecting content. You are building judgment and a practical way to apply what you learn.',
				},
			},
		},
		finalCta: {
			title: 'Start learning today',
			subtitle: 'Start when you are ready and learn at your pace',
			titleLoggedIn: 'Ready to start learning?',
			subtitleLoggedIn: 'Enroll in {{course}} to begin right away',
			titleEnrolled: 'Continue your journey',
			subtitleEnrolled: 'Keep learning with {{course}}',
			enrollButton: 'Enroll now',
			enrollButtonLoggedIn: 'Start this {{mainEntityLabelLower}}',
			continueButton: 'Continue learning',
		},
		enrollmentDialog: {
			whatYouCanDo: 'What happens when you sign up',
			common: {
				createAccount: 'Create account and start here',
				signIn: 'I already have an account',
				viewPlans: 'View plans',
				manageBilling: 'Open billing',
				keepBrowsing: 'keep browsing the catalog',
			},
			anonymous: {
				title:
					'Create your account and start with this {{mainEntityLabelLower}}',
				description:
					'Sign up for free to save this choice. Once your account is ready, you can use one of your two free {{mainEntityLabelPluralLower}} here and keep exploring the catalog.',
				benefitDefault:
					'Start with the {{mainEntityLabelLower}} you are viewing, without being sent through a generic {{collectionEntityLabelLower}}.',
				benefitLogin:
					'If you already have an account, sign in and come back to this same page to continue.',
				benefitCatalog:
					'You can compare plans or keep exploring before deciding which two {{mainEntityLabelPluralLower}} to start with.',
				catalogHint: 'If you prefer to compare first, you can also',
			},
			upgrade: {
				title: 'This {{mainEntityLabelLower}} is included in the premium plan',
				description:
					'Your account is ready. Activate a plan to access {{course}} and the rest of the premium catalog.',
				benefitAccess:
					'Unlock this {{mainEntityLabelLower}} and the rest of the premium content as soon as your plan is active.',
				benefitBilling:
					'Manage the upgrade from billing without losing the context of the {{mainEntityLabelLower}} you were viewing.',
				benefitPlans:
					'If you are still comparing options, review the plans before deciding.',
				catalogHint: 'While you decide, you can',
			},
			confirmation: {
				title: 'Choose this {{mainEntityLabelLower}} for your account',
				description:
					'This {{mainEntityLabelLower}} will stay in your account permanently. You will have {{remaining}} unlock(s) left after this choice.',
				benefitPermanent:
					'This {{mainEntityLabelLower}} is added to your account for good.',
				benefitRemaining:
					'After unlocking it, you will still have {{remaining}} {{mainEntityLabelLower}} unlock(s) left to choose.',
				benefitCatalog:
					'You can keep browsing before spending your remaining unlocks.',
				catalogHint: 'If you prefer to compare first, you can still',
				cancel: 'Back to catalog',
				confirm: 'Unlock {{mainEntityLabelLower}}',
			},
			transientError: 'There was a problem enrolling you.',
			retryButton: 'Try again',
		},
	},
	viewModes: {
		content: 'Content',
		materials: 'Materials',
		diagram: 'Diagram',
		notes: 'Notes',
	},
	categories: {
		subcategories: {
			title: 'Subcategories',
		},
		featuredCourses: 'Featured {{mainEntityLabelPlural}}',
	},
	subcategories: {
		noCourses: 'No {{mainEntityLabelPluralLower}} in this subcategory yet',
		checkBackLater: 'Check back later for new {{mainEntityLabelPluralLower}}',
	},
	filters: {
		title: 'Filters',
		type: 'Type',
		itineraries: '{{collectionEntityLabelPlural}}',
		routes: '{{mainEntityLabelPlural}}',
		categories: 'Categories',
		subcategories: 'Subcategories',
		apply: 'Apply',
		selectCategoryFirst: 'Select a category first',
		mobileDescription: 'Refine the catalog by categories and subcategories.',
		topics: 'Topics',
		languages: 'Languages',
		level: 'Level',
		levels: {
			beginner: 'Beginner',
			intermediate: 'Intermediate',
			advanced: 'Advanced',
		},
		showMore: 'Show {{count}} more',
		showLess: 'Show less',
		clearAll: 'Clear all',
		country: 'Country',
		countryScopeNote: 'Content tailored to {{country}}',
		sortLabel: 'Sort:',
		sort: {
			featured: 'Featured',
			newest: 'Newest',
			popular: 'Most popular',
		},
	},
	search: {
		placeholder: 'Search {{mainEntityLabelPluralLower}}...',
		results: 'Search results',
		noResults: 'No results found',
		tryDifferentKeywords: 'Try different keywords',
	},
	enrollment: {
		success: 'Successfully enrolled in {{mainEntityLabelLower}}',
		error: 'Error enrolling in {{mainEntityLabelLower}}',
		alreadyEnrolled: 'Already enrolled in this {{mainEntityLabelLower}}',
	},
	enrollmentErrors: {
		courseUnavailable: 'This {{mainEntityLabelLower}} is unavailable',
		enrollmentDisabled:
			'Enrollment in this {{mainEntityLabelLower}} is disabled',
		subscriptionRequired:
			'Subscription required for this {{mainEntityLabelLower}}',
		confirmationRequired:
			'Please confirm that you want to spend one of your free-course unlocks.',
		paywallRequired:
			'Your free-course unlocks are already used. Upgrade to Pro to continue.',
		validationFailed: 'Validation failed',
		enrollmentFailed: 'Failed to create enrollment',
		updateFailed: 'Failed to update enrollment',
	},
	preparation: {
		processing: 'Enriching your {{mainEntityLabelLower}}...',
		processingDescription:
			'We are discovering resources and generating content. This may take a few minutes.',
		completed: '{{mainEntityLabel}} enrichment complete!',
		completedDescription:
			'Your {{mainEntityLabelLower}} now has additional resources and content.',
		tracker: {
			initialModuleCompleted:
				'Initial preparation covers the first module. Later topics prepare their text as you open them.',
			initialModuleTopicsReady:
				'{{ready}} of {{total}} topics in the initial scope have readable text',
			preparingStructure: 'Preparing structure and access',
			preparingStructureDescription:
				'We are preparing the {{mainEntityLabelLower}} structure so you can browse it normally.',
			attachingResources: 'Finding and attaching resources',
			attachingResourcesDescription:
				'We are discovering and linking the first useful resources for this {{mainEntityLabelLower}}.',
			creatingContent: 'Creating content',
			creatingContentDescription:
				'We are preparing the learning content in the background.',
			syncingCourse: 'Updating your {{mainEntityLabelLower}}',
			syncingCourseDescription:
				'We are now copying the new resources and content into your {{mainEntityLabelLower}}.',
			topicsReady: '{{ready}} of {{total}} topics with content ready',
			expectation:
				'This usually takes a few minutes. You can keep browsing: topics will activate on their own.',
			delayed:
				'This is taking longer than usual. You can keep using the {{mainEntityLabelLower}}: we will keep completing it in the background.',
			completedTitle: 'Your {{mainEntityLabelLower}} is ready',
			completedDescription:
				'Initial preparation has finished. All canonical content is now in your {{mainEntityLabelLower}}.',
		},
	},
	preparationGate: {
		eyebrow: 'Preparing your {{mainEntityLabelLower}}',
		title: 'We are preparing your {{mainEntityLabelLower}}',
		description:
			'We are getting this {{mainEntityLabelLower}} ready for you. In a couple of minutes you will be able to enter and start normally.',
		note: 'You can wait here while preparation finishes.',
		timeoutTitle: 'Preparation is taking longer than expected',
		timeoutDescription:
			'The course preparation may have encountered an issue. Please try refreshing the page or come back later.',
		retry: 'Try again',
	},
	preparationFallback: {
		title:
			'This {{mainEntityLabelLower}} is available with partial preparation',
		description:
			'Some shared enrichment steps did not finish, so you can continue with the current {{mainEntityLabelLower}} structure while the missing parts are recovered later.',
	},
	emptyModules: {
		title: 'This course does not have modules yet',
		ownerDescription: 'Create a module to organize the course again',
		viewerDescription: 'Content will appear here when modules are available.',
		moduleTitlePlaceholder: 'Module title',
		createModule: 'Create module',
	},
	progress: {
		completed: 'Completed',
		inProgress: 'In progress',
		notStarted: 'Not started',
	},
	addModulesAndTopics: 'Add modules and topics',
	addModulesAndTopicsDescription:
		'Enter module names prefixed with "-". Topics under each module on new lines.',
	bulkPlaceholder: '- Module 1\ntopic A\ntopic B\n- module 2\ntopic C',
	createStudyPlan: {
		title: 'Create study plan',
		advanced: 'Advanced',
		beginner: 'Beginner',
		courseLength: '{{mainEntityLabel}} length (weeks)',
		courseName: '{{mainEntityLabel}} name',
		courseNamePlaceholder: 'e.g., Introduction to quantum computing',
		courseType: '{{mainEntityLabel}} type',
		description:
			'Configure the details for your new AI-generated study plan. The AI will craft a structure with modules and topics based on your preferences.',
		english: 'English',
		expertiseLevel: 'Expertise level',
		foundational: 'Foundational',
		foundationalDescription:
			'Build a strong theoretical understanding of the subject.',
		generate: 'Generate plan',
		intermediate: 'Intermediate',
		language: 'Language',
		practical: 'Practical',
		practicalDescription:
			'Focus on hands-on projects and real-world application.',
		selectLanguage: 'Select language',
		selectLevel: 'Select level',
		spanish: 'Spanish',
		topicsPerWeek: 'Topics per week',
	},
	createCourseDiagram: {
		title: 'Create {{mainEntityLabelLower}} diagram',
	},
	createCourseRouteCards: {
		title: 'Generate {{mainEntityLabelLower}} cards',
	},
	moduleQuickActions: {
		prepareSummaries: 'Prepare summaries',
	},
	topicQuickActions: {
		summary: 'Prepare summary',
		deepDive: 'Prepare deep dive',
		curateResources: 'Curate top resources',
		deepen: 'Deepen',
		moreContent: 'More content options',
		moreResources: 'Gather more resources',
	},
	topics: {
		study: {
			contentLabel: 'Topic content',
			progressLabel: '{{current}} of {{total}}',
			progressAria: 'Topic reading progress',
			resumeTitle: 'You left off here',
			resumeIn: 'in “{{section}}”',
			resumeAction: 'Continue',
			furtherTitle: 'Keep going',
			openOriginal: 'Open the original',
			resourcesCount_one: '{{count}} resource',
			resourcesCount_other: '{{count}} resources',
			backToText: 'Back to the text',
			deleteResourceTitle: 'Remove this resource from the topic?',
			deleteResourceDescription: 'It will no longer appear in this list.',
			resourceActionFailed: 'That did not work. Please try again.',
			untitledResource: 'Untitled resource',
			markStudied: 'Mark as studied',
			studied: 'Studied',
			publicDomain: 'Public domain',
			figureSource: 'Source',
			topicsDone: '{{done}} of {{total}} topics',
			continueHere: 'Continue here',
			statusStarted: 'Started',
			statusStudied: 'Studied',
			nextTopic: 'Next topic',
			nextTopicNumbered: 'Next · Topic {{number}}',
			sectionsCount_one: '{{count}} section',
			sectionsCount_other: '{{count}} sections',
			resumeDismiss: 'Dismiss',
			figureSourceLabel: 'Source of the figure: {{caption}}',
			homeStart: 'Start',
			homeContinue: 'Continue',
			homeTopic: 'Topic {{number}}',
			notesTitle: 'Your notes',
			notesPlaceholder: 'Write down what you want to remember.',
			tableLabel: 'Table, scrolls horizontally',
			keyPoints: 'Key points',
			indexLabel: 'Course',
			indexHide: 'Hide the index',
			indexShow: 'Show the index',
			backToTop: 'Back to top',
			resourceType: {
				video: 'Video',
				post: 'Article',
				book: 'Book',
				pdf: 'PDF',
				image: 'Image',
				url: 'Link',
				file: 'File',
			},
		},
		preparing: {
			title: 'Preparing this topic',
			description:
				'We are copying resources and content in the background. This topic will appear here when the update finishes.',
		},
		textPreparation: {
			failed: 'The topic text could not be prepared',
			description:
				'The text will appear here when preparation finishes. You can use the resources now.',
			retry: 'Prepare text again',
			depthRetry: 'Try again',
			summaryOnly: 'You are reading the summary of this topic',
			depth: {
				pending:
					'The in-depth text is queued. It will appear here without reloading the page.',
				generating:
					'We are writing the in-depth text. It will appear here in a few minutes, without reloading the page.',
				failed:
					'The in-depth text could not be prepared. You can continue with the summary and the resources.',
			},
		},
		zeroState: {
			notes: 'Write a quick note to get started.',
			resources: 'Add sources and materials for this topic.',
			content: 'Create the first piece of content for this topic.',
		},
		notFound: {
			title: 'Topic not found',
			message:
				"The topic you're looking for doesn't exist or you don't have permission to view it.",
			backToCourses: 'Back to my {{mainEntityLabelPluralLower}}',
		},
	},
	resources: {
		notFound: 'Resource not found',
		noContent: 'No content available',
		loading: 'Loading resource...',
		errorLoading: 'Error loading resource',
		tableOfContents: 'Table of contents',
		notes: 'Notes',
		noNotes: 'No notes available',
		navigation: {
			previous: 'Previous',
			next: 'Next',
			backToResources: 'Back to resources',
		},
		actions: {
			download: 'Download',
			share: 'Share',
			addNote: 'Add note',
			edit: 'Edit resource',
		},
		messages: {
			courseNotFound: '{{mainEntityLabel}} not found',
			resourceNotFound: 'The requested resource could not be found.',
			topicNotFound: 'Topic not found',
			moduleNotFound: 'Module not found',
			notEnrolled: 'You are not enrolled in this {{mainEntityLabelLower}}',
			accessDenied: "You don't have permission to view this resource",
		},
		book: {
			error: 'Error loading resource',
			errorDescription: 'There is no information available for this book',
			viewFull: 'View full',
			by: 'By',
			authors: 'Authors',
			author: 'Author',
			publisher: 'Publisher',
			publishedDate: 'Published date',
			pages: 'Pages',
			isbn: 'ISBN',
			description: 'Description',
			categories: 'Categories',
			language: 'Language',
			preview: 'Preview',
			information: 'Information',
			previewError: 'Preview error',
			previewErrorDescription: 'Unable to load the book preview',
			untitled: 'Untitled book',
			noData: 'No data',
			noDataDescription: 'No book information available',
		},
		images: {
			error: 'Error loading images',
			errorDescription: 'Unable to load images for this resource',
			viewFull: 'View full',
			by: 'By',
			source: 'Source',
			description: 'Description',
			preview: 'Preview',
			information: 'Information',
			previewError: 'Preview error',
			previewErrorDescription: 'Unable to load images',
			untitled: 'Untitled',
			noData: 'No data',
			noDataDescription: 'No image information available',
			gallery: 'Gallery',
		},
		video: {
			invalidId: 'Invalid video ID',
			browserNotSupported: 'Your browser does not support the video element.',
			originalSite: 'Original site',
			markers: 'Markers',
			transcript: 'Transcript',
			hide: 'Hide',
			show: 'Show',
			loadError: 'Error loading video',
			loadErrorDescription: 'Try opening the video on its original site',
			sketchfabViewer: 'Sketchfab viewer',
			viewer: '3D viewer',
		},
		model3d: {
			error: 'Error loading model',
			errorDescription: 'No model URL available',
			unsupported: 'Unsupported format',
			unsupportedDescription: 'This type of 3D model is not yet supported',
			loadError: 'Error loading model',
			loadErrorDescription:
				'Try opening the model on its original site using the button above',
			viewOriginal: 'View original',
			source: 'Source',
			description: 'Description',
			preview: 'Preview',
			sketchfabInfo: 'About sketchfab',
			sketchfabInfoDescription:
				'This model is hosted on sketchfab. You can rotate it, zoom in, and interact with the 3D viewer.',
			untitled: 'Untitled model',
		},
	},
}
